module.exports = __webpack_public_path__ + "img/pivx.782df35d.svg";